module.exports = __webpack_public_path__ + "img/flowers-7911617_1280_thumb.baef88b2.jpg";